var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.delay_show)?_c('div',{ref:"div",staticClass:"float-btn",style:({
    width: _vm.itemWidth + 'px',
    height: _vm.itemHeight + 'px',
    left: _vm.left + 'px',
    top: _vm.top + 'px',
  }),on:{"touchstart":(e) => {
      _vm.dragStart(e);
    },"touchend":(e) => {
      _vm.dragEnd(e);
    },"touchmove":function($event){$event.preventDefault();return ((e) => {
      _vm.dragProgress(e);
    }).apply(null, arguments)}}},[_c('img',{attrs:{"src":require("@/assets/insurance/share.png"),"alt":""},on:{"click":_vm.clickButton}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }